import { z } from 'zod';

import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { PhoneSearchFormFields } from './constants';
import type { PhoneSearchFormValues } from './types';

const MIN_PHONE_DIGITS = 7;

export const phoneSearchFormValidationSchema = z.object({
  [PhoneSearchFormFields.phoneNumber]: z
    .string()
    .nonempty({ error: REQUIRED_VALIDATION_MESSAGE })
    .refine(value => Boolean(value && value.trim().length > 0), { message: 'Required' })
    .refine(value => !value || value.replace(/\D/g, '').length >= MIN_PHONE_DIGITS, {
      message: 'Enter a valid phone number',
    }),
}) satisfies z.ZodType<PhoneSearchFormValues>;
